import { Client } from "@/Common/Api/Client";
import { Server } from "@/Common/Operations/operations.server";
import { Relative } from "../Models/Relative";
import { CreateRelativeResponse } from "./Dto/CreateRelativeResponse";
import { RelativeApiMappers } from "./Mappers/RelativeApiMappers";

/** Handle relative API calls. */
class RelativeApiClient {
    /** Create a relative. */
    public static async createRelativeAsync(relative: Relative): Promise<Relative> {
        const request = RelativeApiMappers.FromRelativeToCreateRelativeRequest(relative);
        const response = await Client.postAsync<CreateRelativeResponse>(Server.Myle_CreateRelative, request);
        return RelativeApiMappers.FromCreateRelativeResponseToRelative(response.data);
    }
}

export { RelativeApiClient };
